import * as React from 'react';

interface Props {
  runningTotal: string;
  validatedPurchaseVolume: number;
}

export default function OrderSummaryBox(props: Props) {
  const announcement =
    props.validatedPurchaseVolume === 0
      ? 'Provide a valid quantity'
      : `You require ${props.validatedPurchaseVolume} Tachograph company card${
          props.validatedPurchaseVolume > 1 ? 's' : ''
        } and the amount to pay is £${props.runningTotal}`;

  const liveRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!liveRef.current) return;
    liveRef.current.textContent = '';

    // Small delay required for Firefox (NVDA and Orca) to detect the live region mutation.
    // https://tetralogical.com/blog/2024/05/01/why-are-my-live-regions-not-working/#current-live-region-behaviour
    const timer = setTimeout(() => {
      if (!liveRef.current) return;
      const span = document.createElement('span');
      span.textContent = announcement;
      liveRef.current.appendChild(span);
    }, 50);
    return () => clearTimeout(timer);
  }, [announcement]);

  return (
    <div className="payment-total">
      <h2 className="govuk-heading-m">Order summary</h2>
      <div className="payment-items govuk-body">
        <span id="quantityPlayback">{props.validatedPurchaseVolume}</span>
        {props.validatedPurchaseVolume === 1
          ? 'x company tachograph card'
          : 'x company tachograph cards'}
      </div>
      <div className="govuk-body">Amount to pay</div>
      <div id="cost" className="payment-cost payment-actual govuk-body">
        &pound;{props.runningTotal}
      </div>
      {/* role="alert" doesn't seem to work with Firefox and putting both causes a double announcement */}
      <div
        className="govuk-visually-hidden"
        ref={liveRef}
        aria-live="assertive"
        aria-atomic="true"
      />
    </div>
  );
}
